module.exports = __webpack_public_path__ + "img/BTC.40f88730.svg";